import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=6988bd98&scoped=true"
import script from "./SortableTableHeader.vue?vue&type=script&lang=ts"
export * from "./SortableTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./SortableTableHeader.vue?vue&type=style&index=0&id=6988bd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988bd98",
  null
  
)

export default component.exports